import React from "react";
import { Stack, Typography } from "@mui/material";
import { connect } from "react-redux";
import dayjs from "dayjs";

import { getAuthUser } from "../../redux";

import { HubContextMenu } from "../HubContextMenu";
import HubContextMenuItem from "../HubContextMenu/HubContextMenuItem";
import { HubHookFormWrapper } from "../HubHookFormWrapper";
import { HubHookFormInput } from "../HubHookFormInput";
import { HubButton } from "../inputs";
import { UserDetailIcon } from "../UserDetailIcon";

/*
Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse a eleifend ante, et ornare urna. Cras orci enim, fermentum nec dolor nec, posuere posuere sem. Vivamus imperdiet dictum pharetra.
*/

const mapStateToProps = (state) => ({
  user: getAuthUser(state),
});

const User = connect(mapStateToProps)(({ user }) => (
  <Stack width="100%" padding="8px 14px" gap="5px">
    <UserDetailIcon
      size={16}
      user={{
        name: user?.name,
        email: user?.email,
        hueShift: user?.id,
      }}
      includeEmail={false}
      variant="rounded"
    />
    <Typography variant="caption11">
      {dayjs().utc().format("MM/DD/YYYY")}
    </Typography>
  </Stack>
));

const COMMENT = {
  id: "comment",
  label: "Comment",
  icon: "MessageSquare",
};

const CommentContextItem = ({ handleComment = () => {} }) => {
  const onKeyDown = (e) => {
    e.stopPropagation();
  };

  return (
    <HubContextMenu
      id="comment"
      menuButton={<HubContextMenuItem key="comment" item={COMMENT} />}
      IconButtonProps={{
        sx: {
          padding: 0,
          "&.MuiButtonBase-root": {
            width: "100%",
            "& .MuiButtonBase-root": {
              width: "100%",
              "& .MuiListItemText-root": {
                textAlign: "start",
              },
            },
          },
        },
      }}
      MenuProps={{
        onKeyDown,
        sx: {
          width: "300px",
        },
      }}
    >
      {(onClose = () => {}) => (
        <HubHookFormWrapper onSubmit={handleComment}>
          <Stack padding="10px 15px" gap="10px">
            <User />
            <HubHookFormInput
              name="comment"
              placeholder="Add comment"
              label="Add Comment"
              required
            />
            <Stack direction="row" gap="10px" justifyContent="end">
              <HubButton
                variant="contained"
                size="xsmall"
                label="Cancel"
                color="grey"
                onClick={onClose}
              />
              <HubButton
                variant="contained"
                size="xsmall"
                label="Comment"
                type="submit"
              />
            </Stack>
          </Stack>
        </HubHookFormWrapper>
      )}
    </HubContextMenu>
  );
};

export default CommentContextItem;
